import './styles.scss';

import slugify from 'slugify';

export default function generatePageSummary() {
  const h2s = document.querySelectorAll(
    '.page-content h2:not(.accordion-heading)'
  ) as NodeListOf<HTMLHeadingElement>;

  if (h2s.length === 0) {
    return;
  }

  const pageSummary = document.getElementById('page-summary');
  const pageSummaryWrapper = document.getElementById('page-summary-wrapper');

  if (!pageSummaryWrapper || !pageSummary) {
    return;
  }

  let list = '';

  for (let index = 0; index < h2s.length; index++) {
    const headingText = h2s[index].textContent ?? '';
    const slugifiedText = slugify(headingText, { lower: true });
    h2s[index].setAttribute('id', `${slugifiedText}`);
    list += `
      <li>
        <i class="fas fa-chevron-right"></i>
        <a class="font-weight-medium text-reset" href="#${slugifiedText}">${headingText}</a>
      </li>`;
  }

  pageSummary.innerHTML = `<ul>${list}</ul>`;
  pageSummaryWrapper.classList.remove('d-none');
}
